import axios from '../utils/axios';
import Constants from './types';
import history from '../utils/history';
import { getAuditEventTypes } from './auditEvents';
import { getEntities } from './entities';
import { getIdentifierDomains } from './domains';
import { getPermissions } from './permissions';
import { getStringComparators } from './matching';
import { getTransformationFunctions } from './customFields';
import { getRoles } from './roles';
import { getUsers } from './users';
import store from '../store';
import { getPayloadFromError } from 'src/utils';

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      store.dispatch(logout());
      history.push('/');
      return Promise.reject(null);
    }
    return Promise.reject(error);
  }
);

export const login = data => {
  return dispatch => {
    dispatch(loginRequestAction());
    axios({
      method: 'put',
      url: '/openempi-ws-rest/1.0/security/authenticate-user',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      data: data
    })
      .then(res => {
        dispatch(loginSuccessAction(res.data));
        dispatch(getAuditEventTypes(res.data.sessionId));
        dispatch(getEntities(res.data.sessionId));
        dispatch(getIdentifierDomains(res.data.sessionId));
        dispatch(getPermissions(res.data.sessionId));
        dispatch(getRoles(res.data.sessionId));
        dispatch(getStringComparators(res.data.sessionId));
        dispatch(getTransformationFunctions(res.data.sessionId));
        dispatch(getUsers(res.data.sessionId));
        history.push('/');
      })
      .catch(err => {
        dispatch(loginFailureAction(err));
      });
  };
};

export const loginClearError = () => {
  return {
    type: Constants.LOGIN_CLEARERROR
  };
};

const loginRequestAction = () => {
  return {
    type: Constants.LOGIN_REQUEST
  };
};

const loginSuccessAction = data => {
  return {
    type: Constants.LOGIN_SUCCESS,
    payload: data
  };
};

const loginFailureAction = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.LOGIN_FAILURE,
    payload
  };
};

export const logout = () => dispatch =>
  dispatch({
    type: Constants.SESSION_LOGOUT
  });
